const axios = require('axios')

export default {
  setData ({
    commit
  }) {
    const payload = {
      name: 'new data-log',
      address: 'new adderss'
    }
    console.log(payload)
    commit('setData', payload)
  },
  getLog ({
    commit
  }, params) {
    // console.log('params');
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: process.env.VUE_APP_BASE_URL + 'manage/history/getoperatehistory',
        params: {
          limit: 10,
          offset: params.params.offset
        },
        headers: {
          Authorization: 'Bearer ' + localStorage.token
        }
      }).then(function (data) {
        console.log(data)
        commit('setLog', data)
        resolve()
      })
    })
  }
}
